export const REGISTER_USER = "REGISTER_USER";
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const TOGGLE_AUTH_STATE = "TOGGLE_AUTH_STATE";
export const LISTING_HOUSE = "LISTING_HOUSE";
export const CREATE_OTP = "CREATE_OTP";
export const VERIFY_OTP = "VERIFY_OTP";
export const TOGGLE_CREATE_STATE = "TOGGLE_CREATE_STATE";
export const LOGIN_VIA_THIRDPARTY = "LOGIN_VIA_THIRDPARTY";
export const INVALID = 'INVALID'
export const FORGOT_PASS = 'FORGOT_PASS'
export const REVIVE_PASS = 'REVIVE_PASS'
export const ERROR = 'ERROR'
export const ADD_PROFILE_PIC = 'ADD_PROFILE_PIC'
export const UPDATE_DETAILS  = 'UPDATE_DETAILS'
export const GETALLPOSTS = 'GETALLPOSTS'
export const GETPARTICULARPOST = 'GETPARTICULARPOST'
export const TEMP_DETAIL = 'TEMP_DETAIL'
export const SERVICE_REQUEST = 'SERVICE_REQUEST'
export const NORMAL_REQUEST = "NORMAL_REQUEST"
export const UPDATE_BANK_DETAILS = 'UPDATE_BANK_DETAILS'
